/**
 * Centralized broker data — single source of truth.
 * All broker components import from here.
 * Managed by Forex-System automation.
 */
export const brokers = [
  {
    name: 'XM',
    /* @replace:broker-xm */
      href: 'https://www.fxtrk.net/index.php?web=fxcostguide.com&jump=https://clicks.pipaffiliates.com/c?c=1273925&l=en&p=1',
    highlight: 'Spreads from 0.6 pips',
    benefit: 'Micro, Standard, and Ultra Low accounts with zero commission. $5 minimum deposit makes it one of the most accessible brokers for beginners.',
    regulation: 'ASIC, CySEC, FSC',
    minDeposit: '$5',
    detail: 'Ultra Low · $5 min deposit',
  },
  {
    name: 'Tickmill',
    /* @replace:broker-tickmill */
      href: 'https://www.fxtrk.net/index.php?web=fxcostguide.com&jump=https://tickmill.link/3JPnSGB',
    highlight: 'Raw spreads from 0.0 pips',
    benefit: 'Multi-regulated broker with Raw and Classic accounts. Well-suited for cost-conscious traders who want tight spreads and transparent pricing.',
    regulation: 'FCA, CySEC, FSA, FSCA',
    minDeposit: '$100',
    detail: 'Raw Account · FCA regulated',
  },
  {
    name: 'FxPro',
    /* @replace:broker-fxpro */
      href: 'https://www.fxtrk.net/index.php?web=fxcostguide.com&jump=https://direct-fxpro.com/en/partner/bevkEWLi',
    highlight: 'cTrader + MT4 + MT5',
    benefit: 'Multi-platform access with deep liquidity. Well-suited for algorithmic and manual traders alike.',
    regulation: 'FCA, CySEC, SCB',
    minDeposit: '$100',
    detail: 'Multi-platform · Deep liquidity',
  },
  {
    name: 'FXTM',
    /* @replace:broker-fxtm */
      href: 'https://www.fxtrk.net/index.php?web=fxcostguide.com&jump=https://forextime.com/?Referral=35407',
    highlight: 'Copy trading built-in',
    benefit: 'Social trading with flexible leverage options. Ideal if you want to follow experienced strategy providers.',
    regulation: 'FCA, CySEC, FSCA',
    minDeposit: '$10',
    detail: 'Social trading · $10 min deposit',
  },
  {
    name: 'IC Markets',
    /* @replace:broker-ic-markets */
      href: 'https://www.fxtrk.net/index.php?web=fxcostguide.com&jump=https://www.icmarkets.com/global/en/open-trading-account/live/?camp=6849',
    highlight: 'Raw ECN spreads',
    benefit: 'Interbank-grade pricing with deep liquidity. Favored by scalpers and high-volume day traders.',
    regulation: 'ASIC, CySEC, FSA',
    minDeposit: '$200',
    detail: 'Interbank pricing · ASIC regulated',
  },
] as const;

export type Broker = typeof brokers[number];